













































































import { Vue, Component } from 'vue-property-decorator'
import reportService, { FlexTrade } from '@/services/reportService'
import utility from '@/common/utility'
import SearchFilter from '@/components/search-filter.vue'
import SortHeader from '@/components/SortHeader.vue'
import UpDownBar from '@/views/Report/UpDownBar.vue'

let pageTrades: FlexTrade[] = []

@Component({
  components: {
    SearchFilter,
    SortHeader,
    UpDownBar
  }
})
export default class Trades extends Vue {
  trades: FlexTrade[] = []
  selectedSymbols = new Array<string>()
  symbols: string[] = []
  lastSyncDate = ''
  isLoading = false

  async mounted () {
    await this.loadData(false)
    this.lastSyncDate = await reportService.getLastSyncDate()
  }

  refresh (force: boolean) {
    this.loadData(force)
  }

  async loadData (forceUpdate: boolean) {
    this.isLoading = true
    const data = await reportService.getTrades('Stock', forceUpdate, true)
    this.isLoading = false
    if (data.Error) {
      await this.$alert(data.Error)
      return
    }
    pageTrades = data.Result
    this.symbols = utility.getDistinct(data.Result.map(p => utility.getSymbolDisplay(p.SymbolName, p.Currency)))
    this.trades = utility.freezeArrayItems(pageTrades)
    this.lastSyncDate = await reportService.getLastSyncDate()
  }

  sortSymbol (direction: 'Asc' | 'Desc') {
    utility.sortByFiled(this.trades, direction, p => p.SymbolName)
  }

  private filterSymbols () {
    const filter = pageTrades.filter(p => this.selectedSymbols.length === 0 || this.selectedSymbols.find(q => utility.iSameSymbol(q, p.SymbolName, p.Currency)))
    this.trades = utility.freezeArrayItems(filter)
  }
}
